<template>
  <b-container>
    <div v-if="user.role > 2">
      <!-- first row -->
      <b-row class="mt-3">
        <b-col sm="3" v-if="getAccessRole('UserList', user.role)">
          <b-card bg-variant="light" text-variant="dark" :header="$t('title.userManagement')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="person"></b-icon>
            </div>
            <b-button @click="goTo('UserList')" variant="outline-secondary">{{
              $t("title.userManagement")
            }}</b-button>
          </b-card>
        </b-col>
        <b-col sm="3" v-if="getAccessRole('BuildingList', user.role)">
          <b-card bg-variant="light" text-variant="dark" :header="$t('title.buildingManagement')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="building"></b-icon>
            </div>
            <b-button @click="goTo('BuildingList')" variant="outline-secondary">{{ $t("title.buildingManagement")
            }}</b-button>
          </b-card>
        </b-col>
        <b-col sm="3" v-if="getAccessRole('EditReference', user.role)">
          <b-card bg-variant="light" text-variant="dark" :header="$t('action.editReference')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="cloud"></b-icon>
            </div>
            <b-button @click="goTo('EditReference')" variant="outline-secondary">{{ $t("action.editReference")
            }}</b-button>
          </b-card>
        </b-col>
        <b-col sm="3" v-if="getAccessRole('Budgets', user.role)">
          <b-card bg-variant="light" text-variant="dark" :header="$t('title.budgetManagement')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="bank"></b-icon>
            </div>
            <b-button @click="goTo('Budgets')" variant="outline-secondary">{{
              $t("title.budgetManagement")
            }}</b-button>
          </b-card>
        </b-col>
      </b-row>
      <!-- second row -->
      <b-row class="mt-3">
        <b-col sm="3" v-if="getAccessRole('TaskManagement', user.role)">
          <b-card bg-variant="light" text-variant="dark" :header="$t('title.taskManagement')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="people"></b-icon>
            </div>
            <b-button @click="goTo('TaskManagement')" variant="outline-secondary">{{ $t("title.taskManagement")
            }}</b-button>
          </b-card>
        </b-col>
        <b-col sm="3" v-if="getAccessRole('TaskAssignment', user.role)">
          <b-card bg-variant="light" text-variant="dark" :header="$t('title.groupManagement')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="folder"></b-icon>
            </div>
            <b-button @click="goTo('TaskAssignment')" variant="outline-secondary">{{ $t("title.groupManagement")
            }}</b-button>
          </b-card>
        </b-col>
        <b-col sm="3" v-if="getAccessRole('PlannerGrouping', user.role)">
          <b-card bg-variant="light" text-variant="dark" :header="$t('title.taskAssignment')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="wallet"></b-icon>
            </div>
            <b-button @click="goTo('plannerGroupingList')" variant="outline-secondary">{{ $t("title.taskAssignment")
            }}</b-button>
          </b-card>
        </b-col>
        <b-col sm="3" v-if="getAccessRole('TaskDispatcher', user.role)">
          <b-card bg-variant="light" text-variant="dark" :header="$t('title.TaskDispatcher')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="list-task"></b-icon>
            </div>
            <b-button @click="goTo('TaskDispatcher')" variant="outline-secondary">{{ $t("title.TaskDispatcher")
            }}</b-button>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col sm="3" v-if="getAccessRole('Report', user.role)">
          <b-card bg-variant="light" text-variant="dark" :header="$t('title.report')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="wallet"></b-icon>
            </div>
            <b-button @click="goTo('Report')" variant="outline-secondary">{{ $t("title.report")
            }}</b-button>
          </b-card>
        </b-col>
        <b-col sm="3" v-if="user.email === 'spilote@cogir.net' || user.email === 'abaron@cogir.net'">
          <b-card bg-variant="light" text-variant="dark" :header="$t('title.cleanup')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="wallet"></b-icon>
            </div>
            <b-button @click="goTo('Cleanup')" variant="outline-secondary">{{ $t("title.cleanup")
            }}</b-button>
          </b-card>
        </b-col>
        <b-col sm="3" v-if="user.email === 'spilote@cogir.net' || user.email === 'webideafactory@cogir.net'">
          <b-card bg-variant="light" text-variant="dark" :header="$t('title.keyClientManagement')" class="text-center">
            <div class="h3 mb-2">
              <b-icon icon="wallet"></b-icon>
            </div>
            <b-button @click="goTo('ClientTokenTable')" variant="outline-secondary">{{ $t("title.keyClientManagement")
            }}</b-button>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-alert show variant="info" class="mt-4">
        <p>{{ $t("info.unauthorized") }}</p>
      </b-alert>
    </div>
  </b-container>
</template>

<script>
import { globalF } from './Helpers';

export default {
  mixins: [globalF],
  props: [],
  data: () => ({}),
  mounted() { },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    goTo: function (val) {
      this.$emit("changePage", val);
    },
  },
  components: {},
};
</script>
